import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

const CrossLoginPage: React.FC = () => {
    const [qParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/');
    }, [qParams]);

    return <></>;
};

export default CrossLoginPage;
